import { SxProps, Theme } from "@mui/material/styles";

/**
 * Common styles used across the application
 */

/**
 * Basic info container style - used for displaying entity information
 * Provides consistent vertical layout with spacing, full width, and bottom padding
 */
export const basicInfoContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  width: "100%",
  mt: 1,
  pb: 4,
};

export const serviceActionsSectionStyle: SxProps<Theme> = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
  minWidth: 0,
  px: 1,
  pb: 1.5,
  mb: 2,
};
